import { Check, X } from 'lucide-react';

export type FlowStepState = 'done' | 'current' | 'upcoming' | 'skipped' | 'cancelled';

export interface FlowStep {
  readonly key: string;
  readonly label: string;
  readonly state: FlowStepState;
  /** Optional annotation for reached steps, e.g. when/who. */
  readonly meta?: string;
}

interface FlowTrailProps {
  readonly steps: readonly FlowStep[];
  readonly ariaLabel?: string;
}

/**
 * FORQ Flow — the business-process/status trail (spec 2.2). A calm horizontal stepper that
 * shows where a record stands: done → current → upcoming. It is a lightweight trail rendered
 * with the record, never a heavy up-front process graphic.
 */
export function FlowTrail({ steps, ariaLabel = 'Statusverlauf' }: FlowTrailProps) {
  if (steps.length === 0) return null;
  return (
    <ol className="forq-flow" aria-label={ariaLabel}>
      {steps.map((step, index) => (
        <li
          key={step.key}
          className={`forq-flow__step forq-flow__step--${step.state}`}
          aria-current={step.state === 'current' ? 'step' : undefined}
        >
          <span className="forq-flow__node">
            {step.state === 'done' ? <Check size={12} /> : step.state === 'cancelled' ? <X size={12} /> : index + 1}
          </span>
          <span className="forq-flow__label">{step.label}</span>
          {step.meta ? <span className="forq-flow__meta">{step.meta}</span> : null}
        </li>
      ))}
    </ol>
  );
}
